// extracted by mini-css-extract-plugin
export default {"customStyle":"CardContainer_customStyle__NAsvg"};